import React from "react"

export const CalendarIcon = () => {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.59375 1.75H7.5625V0.632812C7.5625 0.503906 7.43359 0.375 7.30469 0.375H7.13281C6.98242 0.375 6.875 0.503906 6.875 0.632812V1.75H2.75V0.632812C2.75 0.503906 2.62109 0.375 2.49219 0.375H2.32031C2.16992 0.375 2.0625 0.503906 2.0625 0.632812V1.75H1.03125C0.451172 1.75 0 2.22266 0 2.78125V10.3438C0 10.9238 0.451172 11.375 1.03125 11.375H8.59375C9.15234 11.375 9.625 10.9238 9.625 10.3438V2.78125C9.625 2.22266 9.15234 1.75 8.59375 1.75ZM1.03125 2.4375H8.59375C8.76562 2.4375 8.9375 2.60938 8.9375 2.78125V3.8125H0.6875V2.78125C0.6875 2.60938 0.837891 2.4375 1.03125 2.4375ZM8.59375 10.6875H1.03125C0.837891 10.6875 0.6875 10.5371 0.6875 10.3438V4.5H8.9375V10.3438C8.9375 10.5371 8.76562 10.6875 8.59375 10.6875Z" />
    </svg>
  )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Icons/CalendarIcon.js